import React, { useState, useEffect, useImperativeHandle,forwardRef } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Select, Transfer, Tooltip, DatePicker } from 'antd';
import Input from '../../ui/Input';
import TextArea from '../../ui/TextArea';
import { SearchOutlined } from '@ant-design/icons';
import { getOTACodes } from '../../../services/common'
import { PROXIMITY_OPTIONS } from '@constants/index'
import './index.scss'
import { isTagsDisplayed } from '@helpers/FeatureFlags'

let errHandle = false;
const { Option } = Select;
const AddPage = forwardRef((props: any,ref:any) => {
    const [form] = Form.useForm();
    const [transferData, setTransferData] = useState<Array<any>>([])
    const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([])
    const [data, setData] = useState<Array<any>>([])
    const [typeList, setTypeList] = useState<Array<any>>([]);

    useEffect(() => {
        getTransferData()
        getTypeList()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])

    // get transfer
    const getTransferData = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('TAG', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTransferData(res.otacodes)
            setData(res.otacodes)
        } else {
            setTransferData([])
        }
    };
    const getTypeList = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('RST', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length != 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeList(res.otacodes)
        } else {
            setTransferData([])
        }
    }
    const onSearchChange = (e: any) => {
        let res = data.filter(item => item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1)
        setTransferData(res)
    }
    const handleChange = (targetKeys: any) => {
        setTransferTargetKeys(targetKeys)
        props.getTransferData(targetKeys)
    };
 
    
    useImperativeHandle(ref, () => ({
        form: form,
        restoreErr: () => { errHandle = false }
    }));
    useEffect(()=>{
        if (errHandle) {
            props.validateFieldsError();
          } else {
            errHandle = true;
          }
        return ()=>{
            errHandle = false;
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    return <Grid container spacing={0} className="containerSpacing py-0">
            <Grid item xs={12} className="pb-0 px-0 my-0">
                <Form
                    layout="vertical"
                    form={form}
                    name="basic"
                    initialValues={{ remember: true }}
                    onValuesChange={(changedFields, allFields) => {
                        props.validateFieldsError();
                      }}
                >
                    <Row gutter={24}>
                        <Col span={6}>
                            <Form.Item
                                label="Name"
                                name="name"
                                rules={[
                                    { max: 64, message: 'You have reached the max character length of 64' }
                                ]}
                            >
                                <Input maxLength={64} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label="Recreation ID"
                                name="recreationid"
                                rules={[
                                    { max: 16, message: 'You have reached the max character length of 16' }
                                ]}
                            >
                                <Input maxLength={16} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item name='type' label="Type" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select allowClear showSearch>
                                    {typeList.length > 0 && typeList.map((item: any, index: number) => {
                                        return (
                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}></Col>

                        <Col span={12}>
                            <Form.Item
                                label="Type Detail"
                                name="typedetail"
                                help="Lanyon 30 characters"
                                rules={[{ max: 128, message: "You have reached the max character length of 128" }]}
                            >
                            <Input maxLength={128} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label="Proximity"
                                name="proximity"
                                rules={[{ required: true, message: 'This field is required' }]}
                            >
                                <Select allowClear defaultValue="" showSearch>
                                    {Object.values(PROXIMITY_OPTIONS).map(
                                        (item: string, index: number) => (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        ),
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}></Col>

                        <Col span={6}>
                            <Form.Item name='included' label="Included" rules={[{ required: true, message: 'This field is required' }]}>
                                <Select allowClear showSearch>
                                    <Option value="Yes">Yes</Option>
                                    <Option value="No">No</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label="Quantity"
                                name="quanity"
                                rules={[{
                                    required: false,
                                    pattern: new RegExp(/^[0-9]\d*$/, "g"),
                                    message: 'This field should be a number'
                                }]}
                            >
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                        <Col span={6}>
                            <Form.Item
                                label="Distance"
                                name="distance"
                                rules={[{
                                    required: false,
                                    pattern: /^\d*(\.\d*)?$/,
                                    message: 'This field should be a number'
                                }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label="Year Equipment Replaced"
                                name="yearquipreplaced"
                                // rules={[{
                                //     required: false,
                                //     pattern: new RegExp(/^[0-9]\d*$/, "g"),
                                //     message: 'This field should be a number'
                                // }]}
                            >
                                <DatePicker picker="year" />
                            </Form.Item>
                        </Col>
                        <Col span={12}></Col>

                        <Col span={18}>
                            <Form.Item
                                label="Description"
                                name='description'
                                rules={[{ max: 1000, message: 'You have reached the max character length of 1000' }]}
                            >
                            <TextArea maxLength={1000} rows={3} />
                            </Form.Item>
                        </Col>
                        <Col span={6}></Col>

                        { isTagsDisplayed &&
                            <Col span={18}>
                                <Form.Item name='tags' label="Selected Tags">
                                    <Input onChange={onSearchChange} style={{ width: '300px' }} suffix={
                                        <Tooltip title="search">
                                            <SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                        </Tooltip>
                                    } />
                                    <Transfer
                                        dataSource={transferData}
                                        targetKeys={transferTargetKeys}
                                        onChange={handleChange}
                                        render={item => item.codeName}
                                    />
                                </Form.Item>
                            </Col>
                        }
                        <Col span={6}></Col>
                    </Row>
                </Form>
            </Grid>
        </Grid>
})
export default AddPage;
